<template>
  <div class="reports">
    <div class="header">REPORTS</div>
    <div class="report-box">
      <div class="instructions">Select the report you want to generate:</div>
      <div class="report-list">
        <div class="report-option" v-if="reportAccess.PageReportsTNCReportForLAWA">
          <div class="heading">
            <span>1. TNC Report for LAWA</span>
            <a class="button cta small f-right" href="javascript:;" @click="$store.commit('reports/showTNCReport')">Generate Report</a>
          </div>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showRsvpReport}" v-if="reportAccess.PageReportsReservationReports">
          <div class="heading" @click="$store.commit('reports/setShowRsvpReport', !showRsvpReport)">
            <span>
              2. Reservation Reports
              <a class="button cta xsmall daily-rsvp-rep" @click.stop @click="showDailyRsvpReport = true">Daily RSVP Report</a>
            </span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showRsvpReport}"></i>
          </div>

          <transition name="slide-down">
            <rsvp-report v-show="showRsvpReport"></rsvp-report>
          </transition>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showTrxReport}" v-if="reportAccess.PageReportsTransactionReports">
          <div class="heading" @click="$store.commit('reports/setShowTrxReport', !showTrxReport)">
            <span>3. Transaction Reports</span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showTrxReport}"></i>
          </div>

          <transition name="slide-down">
            <trx-report v-show="showTrxReport"></trx-report>
          </transition>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showDriverRatingReport}" v-if="reportAccess.PageReportsDriverReviews">
          <div class="heading" @click="showDriverRatingReport = !showDriverRatingReport">
            <span>4. Driver Reviews</span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showDriverRatingReport}"></i>
          </div>

          <transition name="slide-down">
            <driver-rating-report v-show="showDriverRatingReport"></driver-rating-report>
          </transition>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showSpecializeReport}" v-if="reportAccess.PageReportsSpecialReports">
          <div class="heading" @click="$store.commit('reports/setShowSpecializeReport', !showSpecializeReport)">
            <span>5. Special Reports</span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showSpecializeReport}"></i>
          </div>

          <transition name="slide-down">
            <!-- <newrep v-show="showSpecializeReport"></newrep> -->
            <specialize-report v-show="showSpecializeReport"></specialize-report>
          </transition>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showDirectBill}" v-if="reportAccess.PageReportsDirectBill">
          <div class="heading" @click="$store.commit('reports/setShowDirectBill', !showDirectBill)">
            <span>6. Direct Bill</span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showDirectBill}"></i>
          </div>

          <transition name="slide-down">
            <direct-bill v-show="showDirectBill"></direct-bill>
          </transition>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showDriverPayouts}" v-if="reportAccess.PageReportsPayoutReport">
          <div class="heading" @click="$store.commit('reports/setDriverPayouts', !showDriverPayouts)">
            <span>7. Payout Report</span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showDriverPayouts}"></i>
          </div>

          <transition name="slide-down">
            <driver-payouts v-show="showDriverPayouts"></driver-payouts>
          </transition>
        </div>

        <div :class="{'report-option toggleable':true, 'active':showBackendManger}" v-if="reportAccess.PageReportsBackendManager">
          <div class="heading" @click="showBackendManger = !showBackendManger">
            <span>8. Backend Manager</span>
            <i :class="{'fas fa-chevron-down fa-2x':true, 'show':showBackendManger}"></i>
          </div>

          <transition name="slide-down">
            <backend-manager v-show="showBackendManger"></backend-manager>
          </transition>
        </div>

        <div :class="['report-option toggleable', {'active':showMtech}]" v-if="reportAccess.PageReportsMTech">
          <div class="heading" @click="showMtech = !showMtech">
            <span>9. MTech</span>
            <i :class="['fas fa-chevron-down fa-2x', {'show':showMtech}]"></i>
          </div>

          <transition name="slide-down">
            <mtech v-show="showMtech"></mtech>
          </transition>
        </div>

        <div :class="['report-option toggleable', {'active':showBlockReport}]" v-if="reportAccess.PageReportsBlockReport">
          <div class="heading" @click="showBlockReport = !showBlockReport">
            <span>10. Block Report</span>
            <i :class="['fas fa-chevron-down fa-2x', {'show':showBlockReport}]"></i>
          </div>

          <transition name="slide-down">
            <block-report v-show="showBlockReport"></block-report>
          </transition>
        </div>

        <div :class="['report-option toggleable', {'active':showLGBReport}]" v-if="reportAccess.PageReportsTNCReportLongBeach">
          <div class="heading" @click="showLGBReport = !showLGBReport">
            <span>11. TNC Report - Long Beach</span>
            <i :class="['fas fa-chevron-down fa-2x', {'show':showLGBReport}]"></i>
          </div>

          <transition name="slide-down">
            <lgb-report v-show="showLGBReport"></lgb-report>
          </transition>
        </div>

        <div :class="['report-option toggleable', {'active':showActiveDrivers}]" v-if="reportAccess.PageReportsActiveDrivers">
          <div class="heading" @click="showActiveDrivers = !showActiveDrivers">
            <span>12. Active Drivers</span>
            <i :class="['fas fa-chevron-down fa-2x', {'show':showActiveDrivers}]"></i>
          </div>

          <transition name="slide-down">
            <active-drivers v-show="showActiveDrivers"></active-drivers>
          </transition>
        </div>

        <div :class="['report-option toggleable', {'active':showDriverCount}]" v-if="reportAccess.PageReportsDriverCount">
          <div class="heading" @click="showDriverCount = !showDriverCount">
            <span>13. Driver Count</span>
            <i :class="['fas fa-chevron-down fa-2x', {'show':showDriverCount}]"></i>
          </div>

          <transition name="slide-down">
            <driver-count v-show="showDriverCount"></driver-count>
          </transition>
        </div>

        <div :class="['report-option toggleable', {'active':showLyftReport}]" v-if="reportAccess.PageReportsLyftReport">
          <div class="heading" @click="showLyftReport = !showLyftReport">
            <span>14. Lyft Report</span>
            <i :class="['fas fa-chevron-down fa-2x', {'show':showLyftReport}]"></i>
          </div>

          <transition name="slide-down">
            <lyft-report v-show="showLyftReport"></lyft-report>
          </transition>
        </div>

      </div>
    </div>

    <lawa-report></lawa-report>
    <daily-rsvp-report :modal="showDailyRsvpReport"
      @closeDailyRsvp="showDailyRsvpReport = false"
    ></daily-rsvp-report>
  </div>
</template>

<script>
/* global CONFIG */
// import moment from 'moment'
import DriverRatingReport from './ProviderRatingReport'
import RsvpReport from './RsvpReport'
import LawaReport from './LAWAReport'
import TrxReport from './TrxReport'
import SpecializeReport from './SpecializeReport'
// import newrep from './NewSpecializeReport'
import DirectBill from './DirectBill'
import DriverPayouts from './DriverPayouts'
import BackendManager from './BackendManager'
import Mtech from './mtech'
import DailyRsvpReport from './DailyRsvpReport'
import BlockReport from './BlockReport'
import LgbReport from './LGBReport'
import ActiveDrivers from './ActiveDriverReport'
import DriverCount from './DriverCount'
import LyftReport from './LyftReport'

export default {
  name: 'reports',
  components: {
    DriverRatingReport, RsvpReport, LawaReport,
    TrxReport, SpecializeReport, DirectBill,
    DriverPayouts, BackendManager, Mtech,
    DailyRsvpReport, BlockReport, LgbReport,
    ActiveDrivers, DriverCount, LyftReport
  },
  data () {
    return {
      showDriverRatingReport: false,
      showBackendManger: false,
      showMtech: false,
      showDailyRsvpReport: false,
      showBlockReport: false,
      showLGBReport: false,
      showActiveDrivers: false,
      showDriverCount: false,
      showLyftReport: false
    }
  },
  computed: {
    showRsvpReport () { return this.$store.state.reports.rsvpReport.show },
    showTrxReport () { return this.$store.state.reports.trxReport.show },
    showSpecializeReport () { return this.$store.state.reports.specializeReport.show },
    showDirectBill () { return this.$store.state.reports.directBill.show },
    showDriverPayouts () { return this.$store.state.reports.driverPayouts.show },
    brands () { return this.$store.state.brands },
    reportAccess () { return this.$store.state.session.user.access }
  },
  methods: {
    getAirportList () {
      let self = this
      if (self.$store.state.airports.list.length > 0) { return }

      self.$store.commit('airports/setLoading', true)
      self.$sdk.get('/airports', {}, res => {
        self.$store.commit('airports/setLoading', false)
        let list = []
        res.list.forEach(function (data) {
          let add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2
          let add2 = data.addressLine2 === null ? '' : data.addressLine1
          let title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            })
          }
        })
        self.$store.commit('airports/setList', list)
      })
    },
    getBrands () {
      let self = this
      if (self.brands.loading || self.brands.list.length) return

      self.$store.commit('brands/setLoading', true)
      self.$sdk.get('/brand', {}, res => {
        self.$store.commit('brands/setLoading', false)
        let brands = []
        res.forEach(function (data) {
          brands.push({ id: data.id, name: data.name })
        })
        self.$store.commit('brands/setList', brands)
      })
    }
  },
  mounted () {
    let self = this
    self.getAirportList()
    self.getBrands()

    if (!self.$store.state.brands.list.length) {
      self.$sdk.get('/brand', {}, res => {
        if (res.error) { return }

        if (res.length) {
          self.$store.commit('brands/setList', res)
        }
      })
    }

    setTimeout(function () {
      if (!self.reportAccess.PageAdminReports || 
        (self.reportAccess.PageAdminReports && self.reportAccess.PageAdminReports === '')
      ) {
        self.$router.push('/accessdenied')
      }
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.reports{
  margin-bottom: 170px;
}
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}

.report-box {
  background: #fff;
  max-width: 800px;
  margin: 20px auto;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 1px 1px 3px rgba(0,0,0, .15);
}

.instructions {
  padding: 15px;
  font-weight: 700;
  color: #333;
  font-size: 18px;
  background: #e8e8e8;
  border-bottom: 1px solid #ccc;
}

.report-option {
  background: #f8f8f8;
  border-bottom: 1px solid #ddd;

  & > * {
    display: inline-block;
    vertical-align: middle
  }
  &.active{ background: #fff; }
  &.toggleable{ cursor: pointer; }
  span {
    width: 250px;
    font-weight: 700;
    font-size: 16px;
    color: #555;
    line-height: 40px;
  }
  .f-right { float: right; }
  .heading{
    padding: 10px 15px;
    display: block;

    &:hover{ background: #fff; }
    .fa-chevron-down{
      float: right;
      line-height: 40px;
      color: #999;
      transition: all .4s ease;

      &.show{
        transform: rotate(-180deg);
        color: #777;
      }
    }
  }
}

.daily-rsvp-rep{
  margin-left: 3px;
  vertical-align: middle;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .5s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .report-option .heading .fa-chevron-down {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/index.vue